import i18n from "../i18n";

// ข้อความสถานะแปลตอนเรียกใช้ (getter / i18n.t ในฟังก์ชัน) ค่า id ที่ใช้เทียบกับ backend คงเดิม
export const handleColorStatusUtil = (status_type: string) => {
  if (status_type === "draft") {
    return "default";
  } else if (status_type === "wait") {
    return "warning";
  } else if (status_type === "approve first") {
    return "info";
  } else if (status_type === "not approve first") {
    return "error";
  } else if (status_type === "approve second") {
    return "info";
  } else if (status_type === "not approve second") {
    return "error";
  } else if (status_type === "approve third") {
    return "success";
  } else if (status_type === "not approve third") {
    return "error";
  } else {
    return "warning";
  }
};

export const handleTextStatusUtil = (status_type: string) => {
  if (status_type === "draft") {
    return "Draft";
  } else if (status_type === "wait") {
    return i18n.t("รอหัวหน้าตรวจสอบ");
  } else if (status_type === "approve first") {
    return i18n.t("ผ่านการตรวจสอบจากหัวหน้า");
  } else if (status_type === "not approve first") {
    return i18n.t("ไม่ผ่านการตรวจสอบจากหัวหน้า");
  } else if (status_type === "approve second") {
    return i18n.t("ผ่านการตรวจสอบจากเจ้าหน้าที่");
  } else if (status_type === "not approve second") {
    return i18n.t("ไม่ผ่านการตรวจสอบจากเจ้าหน้าที่");
  } else if (status_type === "approve third") {
    return i18n.t("คำร้องได้รับการอนุมัติ");
  } else if (status_type === "not approve third") {
    return i18n.t("คำร้องไม่ได้รับการอนุมัติ");
  } else {
    return "";
  }
};

export const allStatusLeaveOnline = () => {
  return [
    {
      id: "all",
      get name() { return i18n.t("สถานะทังหมด"); },
    },
    {
      id: "draft",
      name: "Draft",
    },
    {
      id: "wait",
      get name() { return i18n.t("รอหัวหน้าตรวจสอบ"); },
    },
    {
      id: "approve first",
      get name() { return i18n.t("ผ่านการตรวจสอบจากหัวหน้า"); },
    },
    {
      id: "not approve first",
      get name() { return i18n.t("ไม่ผ่านการตรวจสอบจากหัวหน้า"); },
    },
    {
      id: "approve second",
      get name() { return i18n.t("ผ่านการตรวจสอบจากเจ้าหน้าที่"); },
    },
    {
      id: "not approve second",
      get name() { return i18n.t("ไม่ผ่านการตรวจสอบจากเจ้าหน้าที่"); },
    },
    {
      id: "approve third",
      get name() { return i18n.t("คำร้องได้รับการอนุมัติ"); },
    },
    {
      id: "not approve third",
      get name() { return i18n.t("คำร้องไม่ได้รับการอนุมัติ"); },
    },
  ];
};

export const handleColorStatusUtilForApprove = (status_type: string) => {
  if (status_type === "draft") {
    return "default";
  } else if (status_type === "wait") {
    return "warning";
  } else if (status_type === "approve first") {
    return "info";
  } else if (status_type === "not approve first") {
    return "error";
  } else if (status_type === "approve second") {
    return "info";
  } else if (status_type === "not approve second") {
    return "error";
  } else if (status_type === "approve third") {
    return "success";
  } else if (status_type === "not approve third") {
    return "error";
  } else {
    return "warning";
  }
};

export const handleTextStatusUtilForApprove = (status_type: string) => {
  if (status_type === "draft") {
    return "Draft";
  } else if (status_type === "wait") {
    return i18n.t("รอหัวหน้าตรวจสอบ");
  } else if (status_type === "approve first") {
    return i18n.t("รอเจ้าหน้าที่ตรวจสอบ");
  } else if (status_type === "not approve first") {
    return i18n.t("ไม่ผ่านการตรวจสอบจากหัวหน้า");
  } else if (status_type === "approve second") {
    return i18n.t("รอผู้มีอำนาจอนุมัติพิจารณา");
  } else if (status_type === "not approve second") {
    return i18n.t("ไม่ผ่านการตรวจสอบจากเจ้าหน้าที่");
  } else if (status_type === "approve third") {
    return i18n.t("คำร้องได้รับการอนุมัติ");
  } else if (status_type === "not approve third") {
    return i18n.t("คำร้องไม่ได้รับการอนุมัติ");
  } else {
    return "";
  }
};

export const allStatusLeaveOnlineForApprove = () => {
  return [
    {
      id: "all",
      get name() { return i18n.t("ทังหมด"); },
    },
    {
      id: "draft",
      name: "Draft",
    },
    {
      id: "wait",
      get name() { return i18n.t("รอหัวหน้าตรวจสอบ"); },
    },
    {
      id: "approve first",
      get name() { return i18n.t("รอเจ้าหน้าที่ตรวจสอบ"); },
    },
    {
      id: "not approve first",
      get name() { return i18n.t("ไม่ผ่านการตรวจสอบจากหัวหน้า"); },
    },
    {
      id: "approve second",
      get name() { return i18n.t("รอผู้มีอำนาจอนุมัติพิจารณา"); },
    },
    {
      id: "not approve second",
      get name() { return i18n.t("ไม่ผ่านการตรวจสอบจากเจ้าหน้าที่"); },
    },
    {
      id: "approve third",
      get name() { return i18n.t("คำร้องได้รับการอนุมัติ"); },
    },
    {
      id: "not approve third",
      get name() { return i18n.t("คำร้องไม่ได้รับการอนุมัติ"); },
    },
  ];
};
